import { render } from "./BodyBackgroundComponent.vue?vue&type=template&id=363343e1"
import script from "./BodyBackgroundComponent.vue?vue&type=script&lang=js"
export * from "./BodyBackgroundComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__